// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3u5ps","col":"Table_col__3Z_fL","fulfillmentStatus":"Table_fulfillmentStatus__2PROc","emailCol":"Table_emailCol__1RTyP"};